<template>
  <v-layout
    row
    wrap>
    <div style="margin: auto;">
      <div v-if="$store.state.app.linkGooglePlay !== null" style="margin-left: 0px; padding: 10px">
        <a
          target="_blank"
          :href="$store.state.app.linkGooglePlay"><img
            alt="Disponível no Google Play"
            src="https://brcorte.com.br/blog/wp-content/uploads/2021/06/google-play-badge2.png"
            style="width: 200px;"></a>
      </div>
      <div v-if="$store.state.app.linkApple !== null" style="margin: 0px; padding: 10px">
        <a
          target="_blank"
          :href="$store.state.app.linkApple"><img
            alt="Disponível na App Store"
            src="https://brcorte.com.br/blog/wp-content/uploads/2021/06/app_store_badge2.png"
            style="width: 200px;"></a>
      </div>
    </div>
  </v-layout>
</template>
<script>
import {
  mapState
} from 'vuex'
export default {
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user']),
    heightOverflow () {
      return 'margin: 0; padding: 20px; max-height: ' + String(this.$vuetify.breakpoint.height) + 'px; overflow: auto;'
    }
  }

}
</script>
